import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import './styles/globals.css';

// Layout
import Navbar          from './components/layout/Navbar';
import Footer          from './components/layout/Footer';
import ThemeToggle     from './components/layout/ThemeToggle';
import ScrollNavigator from './components/layout/ScrollNavigator';

// UI
import VideoModal from './components/ui/VideoModal';

// Pages
import HomePage         from './pages/HomePage';
import PricingPage      from './pages/PricingPage';
import FeaturesPage     from './pages/FeaturesPage';
import BlogPage         from './pages/BlogPage';
import ContactPage      from './pages/ContactPage';
import IntegrationsPage from './pages/IntegrationsPage';
import AboutPage        from './pages/AboutPage';
import CareersPage      from './pages/CareersPage';
import PartnersPage     from './pages/PartnersPage';
import PressPage        from './pages/PressPage';
import PrivacyPage      from './pages/PrivacyPage';
import TermsPage        from './pages/TermsPage';
import DocsPage         from './pages/DocsPage';
import ChangelogPage    from './pages/ChangelogPage';
import StatusPage       from './pages/StatusPage';
import TutorialsPage    from './pages/TutorialsPage';
import SolutionsPage    from './pages/SolutionsPage';
import BlogPostPage     from './pages/BlogPostPage';
import NotFoundPage     from './pages/NotFoundPage';
function LoginRedirect() {
  useEffect(() => { window.location.replace('https://dashboard.zepliq.com'); }, []);
  return null;
}

const NO_SHELL = ['/login'];

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    } else {
      const el = document.getElementById(hash.slice(1));
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [pathname, hash]);
  return null;
}

function AppShell({ videoOpen, setVideoOpen }) {
  const location = useLocation();
  const hideShell = NO_SHELL.includes(location.pathname);

  return (
    <>
      <ScrollToTop />
      {!hideShell && <Navbar onWatchDemo={() => setVideoOpen(true)} />}
      <main>
        <Routes>
          <Route path="/"             element={<HomePage onWatchDemo={() => setVideoOpen(true)} />} />
          <Route path="/pricing"      element={<PricingPage />} />
          <Route path="/features"     element={<FeaturesPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} />
          <Route path="/blog"         element={<BlogPage />} />
          <Route path="/blog/:slug"   element={<BlogPostPage />} />
          <Route path="/contact"      element={<ContactPage />} />
          <Route path="/about"        element={<AboutPage />} />
          <Route path="/careers"      element={<CareersPage />} />
          <Route path="/partners"     element={<PartnersPage />} />
          <Route path="/press"        element={<PressPage />} />
          <Route path="/privacy"      element={<PrivacyPage />} />
          <Route path="/terms"        element={<TermsPage />} />
          <Route path="/docs"         element={<DocsPage />} />
          <Route path="/changelog"    element={<ChangelogPage />} />
          <Route path="/status"       element={<StatusPage />} />
          <Route path="/tutorials"    element={<TutorialsPage />} />
          <Route path="/solutions"    element={<SolutionsPage />} />
          <Route path="/login"        element={<LoginRedirect />} />
          <Route path="*"             element={<NotFoundPage />} />
        </Routes>
      </main>
      {!hideShell && <Footer />}
      <ThemeToggle />
      {!hideShell && <ScrollNavigator />}
      <VideoModal open={videoOpen} onClose={() => setVideoOpen(false)} />
    </>
  );
}

export default function App() {
  const [videoOpen, setVideoOpen] = useState(false);

  return (
    <HelmetProvider>
      <ThemeProvider>
        <Router>
          <AppShell videoOpen={videoOpen} setVideoOpen={setVideoOpen} />
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}
